import { useState } from 'react';

import { FlowRefModel } from '../../Models/DomainServiceModel';
import { FlowInputDialog } from './FlowInputDialog';
import GenericPropertyInput from './GenericPropertyInput';
import GenericPropertyInputRefContent from './GenericPropertyInputRefContent';

type FlowInputProps = {
	flowRef: FlowRefModel | undefined;
	onFlowRefChange: (flowRef: FlowRefModel | undefined) => void;
	isEditable?: boolean;
};

export default function FlowInput({ flowRef, onFlowRefChange, isEditable = true }: FlowInputProps) {
	const [open, setOpen] = useState(false);

	if (!isEditable) {
		return <GenericPropertyInputRefContent value={flowRef} />;
	}

	return (
		<GenericPropertyInput value={flowRef} onValueChange={onFlowRefChange} onOpen={() => setOpen(true)}>
			<GenericPropertyInputRefContent value={flowRef} />
			{open && <FlowInputDialog open={open} setOpen={setOpen} flowRef={flowRef} onFlowRefChange={onFlowRefChange} />}
		</GenericPropertyInput>
	);
}
